import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { configureApi } from './api/client';
import { loadRuntimeConfig, refreshServerBranding, setRuntimeBranding } from './config';
import { SessionProvider } from './session/SessionProvider';
import './styles/base.css';

const container = document.getElementById('root');

if (container === null) {
    throw new Error('#root introuvable dans index.html.');
}

/**
 * La configuration est chargée AVANT le premier rendu : l'application n'existe
 * pas tant qu'elle ne sait pas à quelle API parler.
 *
 * Pas de `await` de haut niveau : il obligerait à relever la cible de
 * construction, et un socle n'a pas à imposer ça pour trois lignes.
 *
 * L'échec est affiché EN DUR, sans React ni traduction. Si `config.json` manque,
 * rien de ce qui sait rendre un message n'a encore démarré — et une page blanche
 * est le pire diagnostic qu'on puisse laisser à quelqu'un qui déploie.
 */
loadRuntimeConfig()
    .then((config) => {
        configureApi(config.apiBaseUrl);
        setRuntimeBranding(config);
        void refreshServerBranding();

        createRoot(container).render(
            <StrictMode>
                <SessionProvider>
                    <App />
                </SessionProvider>
            </StrictMode>,
        );
    })
    .catch((cause: unknown) => {
        container.textContent = `Configuration introuvable : ${cause instanceof Error ? cause.message : String(cause)}`;
        container.setAttribute('style', 'padding:2rem;font:14px system-ui;color:#b00020');
    });
